import React, { useState } from 'react';
import { UserIcon, LockIcon, MailIcon, LogInIcon, UserPlusIcon } from 'lucide-react';
export const Account: React.FC = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [form, setForm] = useState({
    email: '',
    password: '',
    name: ''
  });
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      name,
      value
    } = e.target;
    setForm({
      ...form,
      [name]: value
    });
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    alert(`Esta es una demo. En una app real, aquí se ${isLogin ? 'iniciaría sesión' : 'registraría'} con los datos proporcionados.`);
  };
  return <div className="max-w-md mx-auto" data-id="element-7">
      <div className="bg-white p-6 rounded-lg shadow-lg" data-id="element-8">
        <div className="flex justify-center mb-6" data-id="element-9">
          <div className="h-20 w-20 rounded-full bg-amber-100 flex items-center justify-center" data-id="element-10">
            <UserIcon size={40} className="text-amber-600" data-id="element-11" />
          </div>
        </div>
        <h2 className="text-xl font-bold mb-6 text-center text-amber-900" data-id="element-12">
          {isLogin ? 'Iniciar Sesión' : 'Crear Cuenta'}
        </h2>
        <div className="bg-amber-50 p-4 rounded-lg mb-6" data-id="element-13">
          <h3 className="font-medium text-amber-800 mb-2 flex items-center" data-id="element-14">
            <LockIcon size={16} className="mr-2" data-id="element-15" />
            Tus datos están seguros
          </h3>
          <p className="text-sm text-amber-700" data-id="element-16">
            Al crear una cuenta, tus preparaciones de café se guardarán en la
            nube y podrás acceder a ellas desde cualquier dispositivo.
          </p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4" data-id="element-17">
          {!isLogin && <div data-id="element-18">
              <label className="block text-sm font-medium text-amber-700 mb-1" data-id="element-19">
                Nombre
              </label>
              <div className="relative" data-id="element-20">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-21">
                  <UserIcon size={18} className="text-amber-500" data-id="element-22" />
                </div>
                <input type="text" name="name" value={form.name} onChange={handleInputChange} className="w-full pl-10 px-3 py-2 border border-amber-300 rounded-md" placeholder="Tu nombre" required={!isLogin} data-id="element-23" />
              </div>
            </div>}
          <div data-id="element-24">
            <label className="block text-sm font-medium text-amber-700 mb-1" data-id="element-25">
              Email
            </label>
            <div className="relative" data-id="element-26">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-27">
                <MailIcon size={18} className="text-amber-500" data-id="element-28" />
              </div>
              <input type="email" name="email" value={form.email} onChange={handleInputChange} className="w-full pl-10 px-3 py-2 border border-amber-300 rounded-md" placeholder="tu@email.com" required data-id="element-29" />
            </div>
          </div>
          <div data-id="element-30">
            <label className="block text-sm font-medium text-amber-700 mb-1" data-id="element-31">
              Contraseña
            </label>
            <div className="relative" data-id="element-32">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-33">
                <LockIcon size={18} className="text-amber-500" data-id="element-34" />
              </div>
              <input type="password" name="password" value={form.password} onChange={handleInputChange} className="w-full pl-10 px-3 py-2 border border-amber-300 rounded-md" placeholder="••••••••" required data-id="element-35" />
            </div>
          </div>
          <button type="submit" className="w-full py-3 bg-amber-600 text-white rounded-md hover:bg-amber-700 font-medium flex items-center justify-center" data-id="element-36">
            {isLogin ? <>
                <LogInIcon size={18} className="mr-2" data-id="element-37" />
                Iniciar Sesión
              </> : <>
                <UserPlusIcon size={18} className="mr-2" data-id="element-38" />
                Crear Cuenta
              </>}
          </button>
        </form>
        <div className="mt-4 text-center" data-id="element-39">
          <button onClick={() => setIsLogin(!isLogin)} className="text-amber-600 hover:text-amber-800 text-sm" data-id="element-40">
            {isLogin ? '¿No tienes cuenta? Regístrate' : '¿Ya tienes cuenta? Inicia sesión'}
          </button>
        </div>
      </div>
      <div className="mt-6 bg-white p-4 rounded-lg shadow" data-id="element-41">
        <h3 className="font-medium text-amber-800 mb-2" data-id="element-42">
          ¿Por qué crear una cuenta?
        </h3>
        <ul className="list-disc pl-5 text-sm text-gray-700 space-y-1" data-id="element-43">
          <li data-id="element-44">Guarda tus preparaciones en la nube</li>
          <li data-id="element-45">Accede a tu historial desde cualquier dispositivo</li>
          <li data-id="element-46">Nunca pierdas tus recetas perfectas</li>
          <li data-id="element-47">Sincronización automática de datos</li>
        </ul>
      </div>
    </div>;
};